<template>
  <div class="about-content">
    <div class="content">

      <p>Unfortunately, we no longer support creating an account or logging in using Snapchat. To log in to an account that was created using Snapchat, you can log in using the phone number that is linked to your account instead. </p>

      <h3>
        What if I didn’t link my phone number to my account?
      </h3>

      <p>Please send an email to <a href='mailto: help@lmk.chat'>help@lmk.chat</a>. In the email, please make sure to have the subject as “Recover Account for {Your Name on LMK}’</p>

      <p>Please make sure your name is spelled exactly as it is on LMK (including any capitalization, punctuation marks, and emojis). For example, “Recover Account for TimothY😁”</p>

      <p>In the email, you must tell us the name and bio on your LMK account. Please spell your name it exactly like it is on LMK. Please also try to do your best to tell us exactly what was on your bio. This information will help up locate your account. </p>

      <p>Furthermore, you must provide a screenshot of your profile on Snapchat (it needs to be full profile on Snapchat app) to verify your identity. Your name and Bitmoji must match that of LMK.</p>

      <p>Lastly, please give us the phone number you want linked to your account. We will add it to your account so that you will be able to log back into your account using your phone number. Please make sure to include your country code and area code (for example, if it is a US phone number, your country code is +1). For example, your phone number should look something like ‘+1 310 534 2859’</p>

      <p>In summary, please make sure to include the following in your email: Name on LMK, Bio on LMK, Screenshot of your profile on Snapchat to verify identity, and your phone number.</p>

      <h3>What if my phone is already used to create another account I had?</h3>

    <p>Unfortunately, we are not able to link your account with a phone number if it is already connected to another LMK account. </p>

    <h3>My phone was linked but I am not getting a verification code. What should I do?</h3>

    <p>Sometimes it may take up to a minute. Please try again. </p>

    <h3>How long will it take?</h3>

    <p>We will try to get this as soon as possible. However, it may take up to 24 hours for someone on our support team to get back to you. </p>

   </div>
  </div>
</template>

<script>
import Appstore from "../common/Appstore.vue";
export default {
  name: "Aboutus",

  components: {
    Appstore,
  }
};
</script>
<style lang="stylus" >
.about-content {
  width: 100vw;
  padding: 0 8vw;
  min-height: 500px;
  background-color: #fff;
  margin-bottom: 50px;
  h1 {
    font-family: Nunito;
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 40px;
    margin: 32px 0 10px 0;
    color: #000000;
  }
  h3 {
    font-family: Nunito;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
    color: #000000;
    margin-top: 30px;
  }
  p {
    margin-top: 30px;
  }
  a {
      text-decoration underline
      color: #000
  }
}
</style>


// WEBPACK FOOTER //
// Instruction.vue